
const API_URL = process.env.REACT_APP_API_SERVER_URL;

const doFetch = async function (request) {
    const res = await fetch(request);
    if (res.ok) {
        return res;
    }
    if (res.status >= 400 && res.status < 500) {
        throw new Error(`CLIENT_ERROR`);
    } else if (res.status >= 500 && res.status < 600) {
        throw new Error('SERVER_ERROR');
    } else {
        throw new Error('Unexpected Error: Something went wrong.');
    }
};

export const useApi = function () {

    const getUserAssignments = async function (accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/user/assignments`, {
            headers: headers
        });

        const res = await doFetch(request);
        return res.json();
    }

    const getHotels = async function (accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/user/hotels`, {
            headers: headers
        });

        const res = await doFetch(request);
        return res.json();
    }

    const getHotel = async function (hotelId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}`, {
            headers: headers
        });

        const res = await doFetch(request);
        return res.json();
    }

    const updateHotel = async function (hotelId, hotel, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}`, {
            headers: headers,
            method: 'PUT',
            body: JSON.stringify(hotel)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const addRoomType = async function (hotelId, roomType, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/roomTypes`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(roomType)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const deleteRoomType = async function (hotelId, category, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/roomTypes/${btoa(category)}`, {
            headers: headers,
            method: 'DELETE',
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const addRoom = async function (hotelId, room, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/rooms`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(room)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');

        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const deleteRoom = async function (hotelId, roomNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/rooms/${btoa(roomNo)}`, {
            headers: headers,
            method: 'DELETE',
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getManagers = async function (accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/managerLogins`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const uploadDocument = async function (imageData, accessToken) {
        const base64Data = imageData.replace(/^data:image\/\w+;base64,/, '');

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'text/plain'
        });
        const request = new Request(`${API_URL}/upload`, {
            headers: headers,
            method: 'POST',
            body: base64Data
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const addGuest = async function (hotelId, guestData, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/guests`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(guestData)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const searchGuest = async function (hotelId, mobile, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/guests/${mobile}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getNextCardNo = async function (hotelId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/nextCardNo`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getAvailableRooms = async function (hotelId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/availableRooms`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCheckedInRooms = async function (hotelId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/checkedInRooms`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const checkInRooms = async function (hotelId, checkInCard, cardNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/checkInRooms/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(checkInCard)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCardNos = async function (hotelId, guestMobile, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/cardNos/${guestMobile}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCheckInCard = async function (hotelId, cardNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/checkInRooms/${cardNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const checkOutRooms = async function (hotelId, cardNo, checkOutCard, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/checkOutRooms/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(checkOutCard)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const updateCheckOutRooms = async function (hotelId, cardNo, checkOutCard, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/updatedCheckOutCard/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(checkOutCard)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const updateCheckInRooms = async function (hotelId, cardNo, checkInCard, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/checkInRooms/${cardNo}`, {
            headers: headers,
            method: 'PUT',
            body: JSON.stringify(checkInCard)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCards = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/cards/range/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCard = async function (hotelId, cardNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/getCard/${cardNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getPayments = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/payments/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const collectAdvance = async function (hotelId, cardNo, paymentDetail, documentS3Id, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            "document-id": documentS3Id
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/collectAdvance/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(paymentDetail)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const transferRoom = async function (hotelId, cardNo, shiftRequest, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/transferRoom/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(shiftRequest)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getImageUrl = async function (documentS3Id, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/image/${documentS3Id}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getExpenses = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/expenses/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getIncomes = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/incomes/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveExpense = async function (hotelId, expense, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/expenses`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(expense)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveIncome = async function (hotelId, income, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/incomes`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(income)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const singleCheckout = async function (hotelId, cardNo, roomDetail, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/singleCheckout/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(roomDetail)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const extendRoom = async function (hotelId, cardNo, checkIn, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/extendRoom/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(checkIn)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const markCardsClose = async function (hotelId, cardNos, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/cardClose`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(cardNos)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const deleteExpense = async function (hotelId, expenseDateTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/expenses/${expenseDateTime}`, {
            headers: headers,
            method: 'DELETE'
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCardsByStatus = async function (hotelId, status, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/cards/status/${status}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCardsByCSV = async function (hotelId, cardNos, accessToken) {
        let cardNoCSV = cardNos.join(',');
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });
        const request = new Request(`${API_URL}/hotel/${hotelId}/cards/csv/${cardNoCSV}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const deletePayment = async function (hotelId, cardNo, paymentId, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/deletePayment/${cardNo}/${paymentId}`, {
            headers: headers,
            method: 'DELETE'
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveTaxInvoice = async function (hotelId, taxInvoice, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/taxInvoice`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(taxInvoice)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getTaxInvoiceByCardNo = async function (hotelId, cardNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/taxInvoice/${cardNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getNextTaxInvoiceNo = async function (hotelId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/nextTaxInvoiceNo`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getTaxInvoicesByMobile = async function (hotelId, guestMobile, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/taxInvoices/${guestMobile}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getTaxInvoicesByRange = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/taxInvoicesByRange/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getAttendances = async function (hotelId, employeeId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/attendance/${employeeId}/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getEmployees = async function (hotelId, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/employees`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveEmployee = async function (hotelId, employee, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/employees`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(employee)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const logAttendance = async function (hotelId, attendance, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/attendance`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(attendance)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const addCheckIn = async function (hotelId, cardNo, checkIn, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/addCheckIn/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(checkIn)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const downloadTaxInvoice = async function (hotelId, cardNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/pdf'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/taxInvoice/${cardNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "TaxInvoice_" + cardNo + ".pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    const getProfitDetails = async function (start, end, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/profit/${start}/${end}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const downloadTaxInvoices = async function (hotelId, start, end, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'vnd.ms-excel'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/taxInvoices/${start}/${end}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "TaxInvoice.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }


    const downloadCards = async function (hotelId, start, end, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/pdf'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/cards/${start}/${end}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "Cards_" + hotelId + ".pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    const getNextEmployeeNo = async function (hotelId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/nextEmployeeNo`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCardsByMobile = async function (hotelId, guestMobile, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/cardsByMobile/${guestMobile}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const downloadTransactions = async function (hotelId, start, end, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/pdf'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/transactions/${start}/${end}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "Transactons_" + hotelId + ".pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    const deleteAttendance = async function (hotelId, employeeId, logdate, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/attendance/${employeeId}/${logdate}`, {
            headers: headers,
            method: 'DELETE'
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getLaundryItems = async function (hotelId, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/laundryItems`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const addLaundryItem = async function (hotelId, laundryItem, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/laundryItems`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(laundryItem)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getMissingLaundry = async function (hotelId, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/missingLaundry`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveLaundry = async function (hotelId, laundry, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/laundry`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(laundry)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const updateLaundry = async function (hotelId, laundry, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/laundry`, {
            headers: headers,
            method: 'PUT',
            body: JSON.stringify(laundry)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const updateLaundries = async function (hotelId, laundryCurrent, laundryPrevious, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/laundries`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify({ "current": laundryCurrent, "previous": laundryPrevious })
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getLaundries = async function (hotelId, start, end, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/laundries/${start}/${end}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getLaundry = async function (hotelId, id, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/laundry/${id}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getAttendancesByHotel = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/attendances/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getBookings = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/bookings/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getBookingsByMobile = async function (hotelId, mobileNumber, status, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/bookingsByMobile/${mobileNumber}/${status}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveBooking = async function (hotelId, advanceBooking, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/bookings`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(advanceBooking)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveIncomes = async function (hotelId, incomes, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/incomes/multiple`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(incomes)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const updateBooking = async function (hotelId, advanceBooking, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/bookings`, {
            headers: headers,
            method: 'PUT',
            body: JSON.stringify(advanceBooking)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getBookingsById = async function (hotelId, mobileNumber, bookingId, status, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/getBookingsById/${mobileNumber}/${bookingId}/${status}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const deleteBookingsById = async function (hotelId, mobileNumber, bookingId, status, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/deleteBookingsById/${mobileNumber}/${bookingId}/${status}`, {
            headers: headers,
            method: 'DELETE'
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getAllCardsByMobile = async function (guestMobile, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/allCardsByMobile/${guestMobile}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const completeBookingsById = async function (hotelId, mobileNumber, bookingId, status, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/completeBookingsById/${mobileNumber}/${bookingId}/${status}`, {
            headers: headers,
            method: 'PATCH'
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const clearAllCache = async function (accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/cache/clear-all`, {
            headers: headers,
            method: 'DELETE'
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const convertRoom = async function (hotelId, cardNo, convertRequest, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/convertRoom/${cardNo}`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(convertRequest)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const sendTaxInvoice = async function (hotelId, cardNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/pdf',
            method: 'POST',
            body: JSON.stringify({})
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/whatsApp/taxInvoice/${cardNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getActiveCheckInsByRange = async function (hotelId, startTime, endTime, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/activeCheckedInRoomsByRange/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCheckedInRoomsByRange = async function (hotelId, startTime, endTime, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/checkedInRoomsByRange/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getCheckedOutRoomsByRange = async function (hotelId, startTime, endTime, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/checkedOutRoomsByRange/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const downloadOnlineCards = async function (hotelId, start, end, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/pdf'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/onlineCards/${start}/${end}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "Cards_" + hotelId + ".pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    const saveOTFTaxInvoice = async function (hotelId, taxInvoice, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/otfTaxInvoice`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(taxInvoice)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getOTFTaxInvoiceByNo = async function (hotelId, invoiceNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/otfTaxInvoice/${invoiceNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getOTFTaxInvoicesByMobile = async function (hotelId, guestMobile, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/otfTaxInvoices/${guestMobile}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getOTFTaxInvoicesByRange = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/otfTaxInvoicesByRange/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const downloadOTFTaxInvoices = async function (hotelId, start, end, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'vnd.ms-excel'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/otfTaxInvoices/${start}/${end}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "TaxInvoice.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    const downloadOTFTaxInvoice = async function (hotelId, invoiceNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/pdf'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/otfTaxInvoice/${invoiceNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "TaxInvoice_" + invoiceNo + ".pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    const getNotifications = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/notifications/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const assignManager = async function (hotelId, managerEmail, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/assignManager`, {
            headers: headers,
            method: 'PATCH',
            body: managerEmail
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const unassignManager = async function (hotelId, managerEmail, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/unassignManager`, {
            headers: headers,
            method: 'PATCH',
            body: managerEmail
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const addUser = async function (user, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/users`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(user)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getBlockedGuest = async function (guestId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/blocked_guests/${guestId}`, {
            headers: headers
        });
        try {
            const res = await doFetch(request);
            const contentLength = parseInt(res.headers.get('content-length') || '0');
            if (contentLength === 0) {
                console.log("Empty response received.");
                return null;
            }
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return res.json();
            } else {
                return res.text();
            }
        } catch (error) {
            console.error("Error fetching blocked guest");
            return null;
        }
    }

    const addBlockedGuest = async function (blockedGuest, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/blocked_guests`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(blockedGuest)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const updatePaymentStatuses = async function (hotelId, updatePaymentStatusesRequest, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/paymentStatuses`, {
            headers: headers,
            method: 'PUT',
            body: JSON.stringify(updatePaymentStatusesRequest)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getReceiptsByRange = async function (hotelId, startTime, endTime, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/receiptsByRange/${startTime}/${endTime}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getReceiptsByMobile = async function (hotelId, guestMobile, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/receiptsByMobile/${guestMobile}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const downloadReceipt = async function (hotelId, receiptNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/pdf'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/download/receipt/${receiptNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "TaxInvoice_" + receiptNo + ".pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    const getReceiptByNo = async function (hotelId, invoiceNo, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/receipts/${invoiceNo}`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        const contentLength = parseInt(res.headers.get('content-length') || '0');
        if (contentLength === 0) {
            console.log("Empty response received.");
            return null;
        }
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const saveReceipt = async function (hotelId, receipt, accessToken) {
        const headers = new Headers({
            authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/receipts`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(receipt)
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    const getNextReceiptNo = async function (hotelId, accessToken) {

        const headers = new Headers({
            authorization: `Bearer ${accessToken}`
        });

        const request = new Request(`${API_URL}/hotel/${hotelId}/nextReceiptNo`, {
            headers: headers
        });

        const res = await doFetch(request);
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return res.json();
        } else {
            return res.text();
        }
    }

    return {
        getUserAssignments, getHotels, updateHotel, getHotel,
        addRoomType, deleteRoomType, addRoom, deleteRoom,
        getManagers, uploadDocument, addGuest, searchGuest,
        getNextCardNo, getAvailableRooms, checkInRooms, getCardNos,
        checkOutRooms, getCheckInCard, updateCheckInRooms,
        getCheckedInRooms, getCards, getCard, getPayments,
        collectAdvance, transferRoom, updateCheckOutRooms,
        getImageUrl, getExpenses, saveExpense, getIncomes,
        saveIncome, singleCheckout, extendRoom, markCardsClose,
        deleteExpense, getCardsByStatus, getCardsByCSV,
        saveTaxInvoice, getTaxInvoiceByCardNo, getNextTaxInvoiceNo,
        getTaxInvoicesByMobile, getTaxInvoicesByRange, saveEmployee,
        getEmployees, logAttendance, getAttendances, addCheckIn,
        downloadTaxInvoice, getProfitDetails, downloadTaxInvoices, downloadCards,
        getNextEmployeeNo, getCardsByMobile, downloadTransactions, deleteAttendance,
        getLaundryItems, addLaundryItem, getMissingLaundry, saveLaundry, updateLaundry,
        updateLaundries, getLaundries, getLaundry, getAttendancesByHotel, getBookings,
        getBookingsByMobile, saveBooking, saveIncomes, updateBooking, getBookingsById,
        deleteBookingsById, deletePayment, getAllCardsByMobile, completeBookingsById,
        clearAllCache, convertRoom, sendTaxInvoice, getCheckedInRoomsByRange, getCheckedOutRoomsByRange,
        getActiveCheckInsByRange, downloadOnlineCards, downloadOTFTaxInvoice, saveOTFTaxInvoice, getOTFTaxInvoiceByNo,
        getOTFTaxInvoicesByMobile, getOTFTaxInvoicesByRange, downloadOTFTaxInvoices, getNotifications,
        assignManager, unassignManager, addUser, getBlockedGuest, addBlockedGuest, updatePaymentStatuses,
        getReceiptsByRange, getReceiptsByMobile, getNextReceiptNo, saveReceipt, getReceiptByNo, downloadReceipt
    };
};